import { ORDERSTATUS } from "../../../models/order";

// Order-type buckets the picker/admin flow pills split on. The `?type=` URL param
// carries one of these alongside a flow preset (approve/manage/send).
// Opening and Relocation are separate for now — the backend cannot yet filter on
// a combined value.
export type InstoreTypeBucket = "week" | "opening" | "relocation";

export const INSTORE_TYPE_BUCKETS: InstoreTypeBucket[] = [
  "week",
  "opening",
  "relocation",
];

// Bucket → backend order_type_instore_name filter.
export const INSTORE_TYPE_BUCKET_FILTER: Record<InstoreTypeBucket, string> = {
  week: "Week",
  opening: "Opening",
  relocation: "Relocation",
};

export const INSTORE_TYPE_BUCKET_LABEL: Record<InstoreTypeBucket, string> = {
  week: "Week",
  opening: "Opening",
  relocation: "Relocation",
};

// Fixed bubble color per type bucket, shared by the flow pills and the instore
// tab badge. Red/orange are avoided (red = promo orders).
export const INSTORE_TYPE_BUCKET_COLOR: Record<InstoreTypeBucket, string> = {
  week: "bg-purple-600 text-white",
  opening: "bg-indigo-500 text-white",
  relocation: "bg-teal-600 text-white",
};

export function isInstoreTypeBucket(
  value: string | null,
): value is InstoreTypeBucket {
  return value === "week" || value === "opening" || value === "relocation";
}

export type InstorePresetKey =
  | "approve"
  | "handle"
  | "manage"
  | "send"
  | "week"
  | "opening-relocation"
  | "all";

export const INSTORE_BASE_PARAMS = {
  limit: 50,
  sort: JSON.stringify({ column: "order_date", order: "desc" }),
};

export const VALID_INSTORE_PRESETS: InstorePresetKey[] = [
  "approve",
  "handle",
  "manage",
  "send",
  "week",
  "opening-relocation",
  "all",
];

export function getInstoreDefaultPreset(
  _isHq: boolean,
  _isAdmin: boolean,
  _isPicker: boolean,
): InstorePresetKey {
  return "all";
}

export function resolveInstorePresetFilter(key: InstorePresetKey): {
  order_status?: string;
  order_type_instore_name?: string;
  paramsOverride?: Record<string, any>;
} {
  if (key === "approve") {
    return {
      order_status: ORDERSTATUS.pending,
      paramsOverride: { limit: 10000 },
    };
  }
  if (key === "handle" || key === "manage") {
    return {
      order_status: ORDERSTATUS.ordered,
      paramsOverride: { limit: 10000 },
    };
  }
  if (key === "send") {
    return {
      order_status: ORDERSTATUS.inProgress,
      paramsOverride: { limit: 10000 },
    };
  }
  if (key === "week") {
    return { order_type_instore_name: "Week" };
  }
  if (key === "opening-relocation") {
    return { order_type_instore_name: "Opening,Relocation" };
  }
  return {};
}
